import * as React from 'react';
import styled from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import TrackSlider from '@components/actions/slider';
import BoxHeader from '@components/layout/box-header';
import { Translate } from 'react-localize-redux';
import ErrorMessage from '@components/basics/error-message';

interface PreviewSliderProps {
  idLow?: string;
  idHigh?: string;
  className?: string;
  duration: number;
  currentStart: number;
  currentLength: number;
  maxTime: number;
  isPlaying: boolean;
  locked?: boolean;
  togglePlay: () => void;
  onUpdate: (value: number, length: number) => void;
}

const updateStart = (
  value: number,
  length: number,
  cb: (value: number, length: number) => void,
  ct: (value: number) => void
) => {
  if (length < 30) {
    return;
  }

  if (value < 0) {
    return;
  }

  cb(value, length);
  ct(value);
};

export const PreviewSlider: React.FC<PreviewSliderProps> = (props) => {
  const {
    currentStart,
    currentLength,
    onUpdate,
    duration,
    maxTime,
    isPlaying,
  } = props;

  const [start, setStart] = React.useState(currentStart);
  const [length, setLength] = React.useState(currentLength);

  React.useEffect(() => {
    setStart(currentStart);
    setLength(Math.round(currentLength));
  }, [currentStart]);

  const handleUpdate = (start, length, _duration, _maxTime, onUpdate) => {
    if (start + Math.floor(length) > duration) {
      return;
    }
    setLength(Math.floor(length));
    updateStart(start, length, onUpdate, setStart);
  };

  return (
    <>
      <Box className={props.className} noBorderTop noBorderBottom>
        <BoxHeader
          title={
            <Translate id="RELEASE.TRACK_INFO.TRACK.AUDIO_PREVIEW.TITLE" />
          }
          text={<Translate id="RELEASE.TRACK_INFO.TRACK.AUDIO_PREVIEW.TEXT" />}
        />
        <Flex
          className="slider-wrapper"
          justifyContent="space-between"
          alignItems="center"
        >
          {duration ? (
            <TrackSlider
              className="track-slider"
              trackLength={duration}
              startTime={start}
              length={length}
              maxTime={maxTime}
              onChange={
                props.locked
                  ? () => null
                  : (value, length) =>
                      handleUpdate(value, length, duration, maxTime, onUpdate)
              }
              isPlaying={isPlaying}
              onTogglePlay={() => props.togglePlay()}
            />
          ) : null}
        </Flex>
      </Box>
      {length < 30 && (
        <ErrorMessage
          className="mt-10"
          hasBackground
          errorId={'RELEASE.INVALID_PREVIEW_LENGTH'}
        />
      )}
    </>
  );
};

export default styled(PreviewSlider)`
  .slider-wrapper {
    .track-slider {
      flex: 0 0 100%;

      @media ${({ theme }) => theme.device.laptopL} {
        flex: 0 0 100%;
      }
    }
  }
`;
